module.exports = __webpack_public_path__ + "img/long-neck-3.9130f2da.webp";